import { useCallback } from "react";
import { useAuthQuery } from "./useAuthQuery";

export const useGetFuelRequests = (queryBody, options = {}) => {
  const select = useCallback((response) => {
    return response?.data?.data?.fuelRequests;
  }, []);

  const response = useAuthQuery(
    {
      method: "POST",
      url: "/fuelrequest/list",
      data: queryBody,
    },
    {
      ...options,
      queryKey: ["fuel-requests", queryBody],
      select,
      refetchInterval: 10000,
      refetchOnWindowFocus: false,
    }
  );

  return response;
};
